import { render, staticRenderFns } from "./salesTableFbj.vue?vue&type=template&id=fa42fe32"
import script from "./salesTableFbj.vue?vue&type=script&lang=js"
export * from "./salesTableFbj.vue?vue&type=script&lang=js"
import style0 from "./salesTableFbj.vue?vue&type=style&index=0&id=fa42fe32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports